import type { ContactInfo } from './exportTypes'

interface ImageExportLayoutProps {
  diagramDataUrl: string
  title: string
  customerName?: string
  customerLogoUrl?: string | null
  generatedAt: string
  seContact?: ContactInfo
  aeContact?: ContactInfo
}

export function ImageExportLayout({
  diagramDataUrl,
  title,
  customerName,
  customerLogoUrl,
  generatedAt,
  seContact,
  aeContact,
}: ImageExportLayoutProps) {
  const hasContacts = seContact?.name || seContact?.email || aeContact?.name || aeContact?.email
  const formattedDate = new Date(generatedAt).toLocaleDateString()

  return (
    <div
      style={{
        width: '1920px',
        height: '1080px',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'Arial, sans-serif',
      }}
    >
      {/* Header */}
      <div
        style={{
          height: '60px',
          padding: '0 30px',
          borderBottom: '1px solid #E0E0E0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexShrink: 0,
        }}
      >
        {/* Header Left - Customer branding */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {customerLogoUrl && (
            <img
              src={customerLogoUrl}
              alt="Customer logo"
              style={{
                width: '40px',
                height: '40px',
                objectFit: 'contain',
              }}
            />
          )}
          {customerName && (
            <span
              style={{
                fontSize: '18px',
                fontWeight: 'bold',
                color: '#333333',
              }}
            >
              {customerName}
            </span>
          )}
          {!customerName && !customerLogoUrl && (
            <span
              style={{
                fontSize: '18px',
                fontWeight: 'bold',
                color: '#333333',
              }}
            >
              Architecture Diagram
            </span>
          )}
        </div>

        {/* Header Right - Title and date */}
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
          }}
        >
          <span style={{ fontSize: '14px', color: '#666666' }}>{title}</span>
          <span style={{ fontSize: '10px', color: '#999999' }}>Generated: {formattedDate}</span>
        </div>
      </div>

      {/* Diagram Area */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px',
          overflow: 'hidden',
        }}
      >
        <img
          src={diagramDataUrl}
          alt="Diagram"
          style={{
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
          }}
        />
      </div>

      {/* Footer */}
      <div
        style={{
          height: '40px',
          padding: '0 30px',
          borderTop: '1px solid #E0E0E0',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexShrink: 0,
        }}
      >
        {/* Footer Left */}
        <div>
          <span style={{ fontSize: '10px', color: '#999999' }}>
            Created with HiveMQ Stories 2.0
          </span>
        </div>

        {/* Footer Center - Contacts */}
        {hasContacts && (
          <div style={{ display: 'flex', gap: '40px' }}>
            {(seContact?.name || seContact?.email) && (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span
                  style={{
                    fontSize: '8px',
                    color: '#666666',
                    fontWeight: 'bold',
                    marginBottom: '2px',
                  }}
                >
                  Solutions Engineer
                </span>
                {seContact.name && (
                  <span style={{ fontSize: '9px', color: '#333333' }}>{seContact.name}</span>
                )}
                {seContact.email && (
                  <span style={{ fontSize: '8px', color: '#666666' }}>{seContact.email}</span>
                )}
              </div>
            )}
            {(aeContact?.name || aeContact?.email) && (
              <div style={{ display: 'flex', flexDirection: 'column' }}>
                <span
                  style={{
                    fontSize: '8px',
                    color: '#666666',
                    fontWeight: 'bold',
                    marginBottom: '2px',
                  }}
                >
                  Account Executive
                </span>
                {aeContact.name && (
                  <span style={{ fontSize: '9px', color: '#333333' }}>{aeContact.name}</span>
                )}
                {aeContact.email && (
                  <span style={{ fontSize: '8px', color: '#666666' }}>{aeContact.email}</span>
                )}
              </div>
            )}
          </div>
        )}

        {/* Footer Right */}
        <div>
          <span style={{ fontSize: '10px', color: '#999999' }}>www.hivemq.com</span>
        </div>
      </div>
    </div>
  )
}
